<template>
  <pdf src="/assets/pdf/transparencia.pdf"></pdf>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  components: {
    pdf
  }
}
</script>
